export type Copyright = Readonly<{
    line1: string;
    line2?: string;
}>;

export const initialCopyrightState = {
    line1: '',
};
